
import { mixins } from 'vue-class-component';
import WalletMixin from '@/mixins/wallet';

export default class Connect extends mixins(WalletMixin) {
  showDisconnectMenu = false;

  toggleDisconnectMenu(): void {
    if (!this.wrongChain) {
      this.showDisconnectMenu = !this.showDisconnectMenu;
    }
  }

  closeDisconnectMenu(): void {
    this.showDisconnectMenu = false;
  }

  async disconnectAndClose(): Promise<void> {
    this.closeDisconnectMenu();
    await this.disconnectWallet();
  }
}
